/**
 * 10 curated warm colors for role badges.
 * Admins pick one of these when creating a role.
 */
const ROLE_COLORS = [
  { name: 'Ruby',      hex: '#E63946' },
  { name: 'Coral',     hex: '#F4845F' },
  { name: 'Amber',     hex: '#F59E0B' },
  { name: 'Tangerine', hex: '#F97316' },
  { name: 'Rose',      hex: '#EC4899' },
  { name: 'Violet',    hex: '#8B5CF6' },
  { name: 'Sapphire',  hex: '#3B82F6' },
  { name: 'Emerald',   hex: '#10B981' },
  { name: 'Teal',      hex: '#14B8A6' },
  { name: 'Slate',     hex: '#64748B' },
];

export default ROLE_COLORS;
